import ProgramPreviewView from './program_preview_view';

const ProgramPreview = ProgramPreviewView;
export default ProgramPreview;
